export const BaseURL = "https://www.geosurvey.co.in/api/v1"; //production server
// export const BaseURL = "http://13.200.130.210:9000/api/v1"; // UAT server
// export const BaseURL = "http://10.0.20.187:8000/api/v1"; // Bhugol server

